import {
  useState,
  useEffect
} from 'react';

// ...

export function useQuery(fetcher) {
  const [data, setData] = useState(null);

  useEffect(() => {
    async function run() {
      const data = await fetcher();
      
      setData(data);
    }

    run();
  }, [fetcher])

  return data;
}